import { WidgetBase } from "./WidgetBase";
import { WidgetTypes } from "./WidgetTypes";
import { WidgetController } from "../WidgetController";
import { WidgetAnalyseComponent } from "../Components/WidgetAnalyseComponent";
import { PopupAnalyseComponent } from "../Popups/PopupAnalyseComponent";
import { ChartTypes } from "../Charts/ChartTypes";
import { app } from "../../../Frame/App";
import { LanguageString } from "../../../Model/LanguageString";

export class WidgetAnalyseProps {
    public templateIds: number[];
    public title: LanguageString;
    public chartType: ChartTypes;
    public showWithTable: boolean;
    public splitBy: "ampel" | "status"

    constructor() {
        this.templateIds = [];
        this.chartType = ChartTypes.Donut;
        this.title = new LanguageString();
    }
}

export class WidgetAnalyse extends WidgetBase {
    props: WidgetAnalyseProps;

    constructor(controller: WidgetController) {
        super(controller, 1, 2);
        this.props = new WidgetAnalyseProps();
    }

    getType(): WidgetTypes {
        return WidgetTypes.Analyse;
    }

    loadProps(jsonProps: string): void {
        if (jsonProps && jsonProps.length > 0) {
            this.props = JSON.parse(jsonProps);

            if (!this.props.templateIds) {
                this.props.templateIds = [];
            }

            if (this.props.title == null)
                this.props.title = new LanguageString();

            if (app.isNullOrUndefined(this.props.chartType)) {
                this.props.chartType = ChartTypes.Donut;
            }
        }
        else
            this.props.title = new LanguageString();
    }

    saveProps(): string {
        return JSON.stringify(this.props);
    }

    createComponent(column: number, row: number, colSpan?: number, rowSpan?: number): HTMLElement {
        this.column = column;
        this.row = row;
        this.colSpan = colSpan ? colSpan : this.minColSpan;
        this.rowSpan = rowSpan ? rowSpan : this.minRowSpan;
        this.component = new WidgetAnalyseComponent({
            widget: this
        });
        return this.component.render();
    }

    showPopup(): void {
        let popup = new PopupAnalyseComponent({ widget: this });
        document.body.appendChild(popup.render());
    }
}